import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { licenseAPI } from '@/lib/api/license';

export function LicenseBanner() {
  const { data } = useQuery({ queryKey: ['license'], queryFn: licenseAPI.get });
  if (!data || data.ui_enabled === false || data.state === 'active') return null;
  const msg =
    data.state === 'expired'
      ? 'Członkostwo wygasło — odnów klucz, by otrzymywać aktualizacje skill-packów.'
      : 'Brak/niewalidny klucz licencyjny — wgraj license.key w Ustawieniach, by aktywować aktualizacje.';
  return (
    <div className="bg-amber-50 text-amber-900 text-sm px-4 py-2 border-b border-amber-200">
      {msg}{' '}
      <Link to="/app/settings" className="underline font-medium">
        Ustawienia
      </Link>
    </div>
  );
}
